import { render, staticRenderFns } from "./ClosePromptModal.vue?vue&type=template&id=1f830ec8&"
import script from "./ClosePromptModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClosePromptModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports